import { AuxiliumComponent } from "../auxilium-component";

export default class FrameHeader extends AuxiliumComponent {
	static observableBooleans = ["restrict-width"];

	parsedCallback() {
		this.classList.add("layout-frame__header");
		const header = document.createElementWithContents("header", this.childNodes);

		if (this.restrictWidth) {
			header.classList.add("container");
		}

		this.appendChild(header);
	}
}
